<template>
  <form class="form form-delete-account" @submit.prevent="postForm">

    <!--checkboxes had been removed-->

    <slide-y-up-transition :duration="400" :delay="500">
      <ion-button v-if="show"
                  mode="ios"
                  expand="block"
                  class="mt-20"
                  :disabled="disabled"
                  @click="postForm">
        <span>Usuń moje konto</span>
      </ion-button>
    </slide-y-up-transition>
  </form>
</template>

<script>
import api from '@/services/Api';
import goTo from '@/mixins/goto';
import {mapState} from "vuex";

export default {
  name: 'FormDeleteAccount',
  mixins: [goTo],
  props: ['disabled'],
  computed: {
    ...mapState({
      loading: state => state.profile.loading,
      errors: state => state.profile.errors
    })
  },
  data() {
    return {
      show: false
    }
  },
  mounted() {
    this.show = true
  },
  methods: {
    postForm() {
      this.$ionic.alertController
          .create({
            header: 'Potwierdź',
            message: 'Czy na pewno chcesz usunąć swoje konto na Portalu Gastro?',
            buttons: [
              {
                text: 'Anuluj',
                role: 'cancel',
                handler: () => {
                },
              },
              {
                text: 'Usuń',
                handler: () => {
                  let url = '/users/account/delete';
                  api({url: url, method: 'POST'}).then(resp => {
                    //
                    this.$store.dispatch('GLOBAL_TOAST', 'Usunęliśmy Cię poprawnie. Za 4 sekundy nastąpi automatyczne wylogowanie.');
                    //
                    setTimeout(() => {
                      this.$store.dispatch('AUTH_LOGOUT_REQUEST').then(() => {
                        this.$router.push({name: 'Login'}).catch(err => {})
                        return this.$store.dispatch('GLOBAL_TOAST', 'Wylogowano poprawnie.');
                      })
                    }, 4000);
                  })
                }
              }
            ],
            mode: 'md'
          })
          .then(a => a.present())
    }
  }
}
</script>